import type { RiskLevel, DiceRollResult } from "../types/game";

const LOW_RISK_TABLE: Record<number, number> = {
  1: 0.9,
  2: 1.0,
  3: 1.1,
  4: 1.15,
  5: 1.2,
  6: 1.25,
};

const HIGH_RISK_TABLE: Record<number, number> = {
  1: 0.4,
  2: 0.6,
  3: 0.9,
  4: 1.3,
  5: 1.6,
  6: 2.0,
};

export type DiceLabel = "diceJackpot" | "diceBigWin" | "diceNiceGain" | "diceBreakEven" | "diceSmallLoss" | "diceBigLoss";

function labelKeyForMultiplier(m: number): DiceLabel {
  if (m >= 2.0) return "diceJackpot";
  if (m >= 1.5) return "diceBigWin";
  if (m >= 1.2) return "diceNiceGain";
  if (m >= 1.0) return "diceBreakEven";
  if (m >= 0.8) return "diceSmallLoss";
  return "diceBigLoss";
}

export function rollDie(): number {
  return Math.floor(Math.random() * 6) + 1;
}

export function resolveRoll(roll: number, amount: number, risk: RiskLevel): DiceRollResult {
  const table = risk === "low" ? LOW_RISK_TABLE : HIGH_RISK_TABLE;
  const multiplier = table[roll];
  const newValue = Math.round(amount * multiplier);
  const netGain = newValue - amount;
  return { roll, multiplier, netGain, label: labelKeyForMultiplier(multiplier) };
}

export function passiveIncomeRate(risk: RiskLevel): number {
  if (risk === "bond") return 0.04;
  return risk === "low" ? 0.05 : 0.10;
}
